<template>
    <div class="all">
        <!-- 筛选 -->
        <div class="screen clearfix">
            <div class="fl">
                <div class="corm fr clearfix">
                    <router-link class="element" to='/analysis/presentationCenter'>简报列表</router-link>
                    <router-link class="element" to='/analysis/ordinaryTemplate'>自定义简报模板</router-link>
                    <router-link class="element" to='/analysis/timingTemplate'>定时报告模板</router-link>
                    <router-link class="element curr" to='/analysis/timelyReporting'>定时报告</router-link>
                </div>
            </div>
        </div>
        <!-- 预警信息列表 -->
        <div class="warp mt20">
            <div class="warp-body">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="45%">
                        <col width="35%">
                        <col width="20%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>报告名称</th>
                            <th>创建时间</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportList" :key="index">
                            <td>{{item.briefdocName}}</td>
                            <td>{{item.createTime}}</td>
                            <td>
                                <div class="table-all-icons">
                                    <i class="icons eye-icon" title="预览" @click="showhtml(item.htmlUrl)" ></i>
                                    <i class="icons word-icon disabled" title="下载Word" v-if="item.word==''"></i>
                                    <i class="icons word-icon" title="下载Word" @click="downWord(item.word)" v-if="item.word!=''"></i>
                                    <i class="icons pdf-icon disabled" title="下载PDF" v-if="item.pdf==''"></i>
                                    <i class="icons pdf-icon" title="下载PDF" @click="downPdf(item.pdf)" v-if="item.pdf!=''"></i>
                                    <i class="icons del-icon" title="删除简报" @click="delReport(item.id)"></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- 分页 -->
                <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
            </div>
        </div>
        <Dialog ref="delDialog" :callback="delModal">
            <div slot="mdBox" >
                <div class="ac">确定删除报告吗？</div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import page from '../../../components/page.vue';
import Dialog from '../../../components/dialog.vue';
export default {
    data() {
        return {
            caseId:'',
            reportList:[],
            reportTemplate:[],
            currentPage: 1,//当前页码
            limit: 20,//每页显示条数
            totalCount:0,//总条数
            templateId:0,
            reportId:0,
            isShow:true,
            nodata:false
        }
    },
    components:{
        page,Dialog
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.dataAjax();
        })
    },
    created() {
		// 获取缓存方案数据
        this.caseId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('report/timing-report/report-list',{sid:that.caseId,perpage:that.limit,page:that.currentPage},r=>{
                that.$parent.loadModal(false);
                that.$utils.returnCode(r,function(){
                    that.reportList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata = true;
                        return
                    }else{
                        that.nodata = false;
                    }
                    that.totalCount = Math.floor(r.data.count);   
                });
            });
        },
        getTableData() {
           this.dataAjax()
        },
        //删除报告
        delReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.delDialog.showMaskFun();
        },
        delModal(){
            let that = this;
            that.$refs.delDialog.closeMask();
            that.$api.get('report/report/delete',{id:that.reportId},r=>{
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功！',200);
                    that.currentPage = 1;
                    that.dataAjax();
                });
            });
        },
        //下载html
        showhtml(url){
            window.open(url,'_blank')
        },
        //下载word
        downWord(url){
            window.location.href = url;
        },
        //下载pdf
        downPdf(url){
            window.open(url,'_blank')
            // window.location.href = url;
        },
	}
}
</script>
<style scoped>
    .w325{width:325px}
</style>




// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/timelyReporting.vue